import React from 'react'
import { INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { IModalAction, MODAL_TYPES, ModalBase, ModalSize } from 'transfix-ui/components/Modals'

export interface IAddEntityModalProps extends JSX.ElementChildrenAttribute {
  open?: boolean
  title: string
  error?: string | string[]
  actions?: IModalAction[]
  dataTest?: string
  className?: string
  isClose?: boolean
  modalClassName?: string
  size?: ModalSize
  onClose: (action?: string) => any
}

export const AddEntityModal: React.FunctionComponent<IAddEntityModalProps> = ({
  error,
  dataTest,
  className = '',
  open,
  title,
  actions = [],
  onClose,
  isClose,
  children,
  modalClassName = 'relative',
  size = 6,
}) => (
  <ModalBase
    closeOnBackdropClick
    open={open}
    title={title}
    actions={actions}
    onClose={onClose}
    isClose={isClose}
    dataTest={dataTest}
    modalType={MODAL_TYPES.form}
    size={size}
    className={className}
    modalClassName={modalClassName}
    bodyClassName='fp-entity-modal'
    inlineMessageProps={
      error && error.length
        ? {
            message:
              typeof error === 'string' ? (
                <span data-test={`${dataTest}-error`}>{error}</span>
              ) : (
                <ul>
                  {error.map(entry => (
                    <li>{entry}</li>
                  ))}
                </ul>
              ),
            type: INLINE_MESSAGE_VARIANTS.ALERT,
          }
        : undefined
    }>
    {children}
  </ModalBase>
)
